// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    eventCoachList as eventCoachListApi,
    eventCoachShow as eventCoachShowApi,
    eventCoachFilter as eventCoachFilterApi,
    eventCoachUpdate as eventCoachUpdateApi,
    eventCoachUpdateViewedStatus as eventCoachUpdateViewedStatusApi,
} from "../../../helpers/api/event_coach"

import {
    authApiResponseSuccess,
    authApiResponseError,
} from "./actions"
import { EventCoachActionTypes } from './constants';



function* list() {
    try {
        const response = yield call(eventCoachListApi);
        console.log(response)
        const event_coaches = response.data
        // NOTE - You can change this according to response format from your api
        yield put(authApiResponseSuccess(EventCoachActionTypes.LIST_EVENT_COACH, event_coaches));
    } catch (error) {
        console.log(error)
        yield put(authApiResponseError(EventCoachActionTypes.LIST_EVENT_COACH, error));
    }
}

function* filter({ payload: { data } }) {
    try {
        console.log(data)
        const response = yield call(eventCoachFilterApi, { data });
        const event_coaches = response.data;

        yield put(authApiResponseSuccess(EventCoachActionTypes.FILTER_EVENT_COACH, event_coaches));
    } catch (error) {
        yield put(authApiResponseError(EventCoachActionTypes.FILTER_EVENT_COACH, error));
    }
}

function* show({ payload: { data } }) {
    try {
        const response = yield call(eventCoachShowApi, data);
        const event_coach = response.data.event_coach;

        yield put(authApiResponseSuccess(EventCoachActionTypes.SHOW_EVENT_COACH, event_coach));
    } catch (error) {
        yield put(authApiResponseError(EventCoachActionTypes.SHOW_EVENT_COACH, error));
    }
}

function* update(action) {

    try {
       const response = yield call(eventCoachUpdateApi, {id: action.payload.id, data: action.payload.data});

        yield put(authApiResponseSuccess(EventCoachActionTypes.UPDATE_EVENT_COACH, {event_coaches: response.data.data.event_coaches }));
    } catch (error) {
        yield put(authApiResponseError(EventCoachActionTypes.UPDATE_EVENT_COACH, error));
    }
}

function* updateViewedStatus(action) {

    try {
        const response = yield call(eventCoachUpdateViewedStatusApi, {});

        yield put(authApiResponseSuccess(EventCoachActionTypes.UPDATE_VIEWED_STATUS, {event_coaches: response.data.data.event_coaches}));
    } catch (error) {
        yield put(authApiResponseError(EventCoachActionTypes.UPDATE_VIEWED_STATUS, error));
    }
}

export function* watchEventCoachList(): any {
    yield takeEvery(EventCoachActionTypes.LIST_EVENT_COACH, list);
}

export function* watchEventCoachFilter(): any {
    yield takeEvery(EventCoachActionTypes.FILTER_EVENT_COACH, filter);
}

export function* watchEventCoachShow(): any {
    yield takeEvery(EventCoachActionTypes.SHOW_EVENT_COACH, show);
}

export function* watchEventCoachUpdate(): any {
    yield takeEvery(EventCoachActionTypes.UPDATE_EVENT_COACH, update);
}

export function* watchEventCoachUpdateViewedStatus(): any {
    yield takeEvery(EventCoachActionTypes.UPDATE_VIEWED_STATUS, updateViewedStatus);
}


function* eventCoachSaga(): any {
    yield all([
        fork(watchEventCoachList),
        fork(watchEventCoachShow),
        fork(watchEventCoachFilter),
        fork(watchEventCoachUpdate),
        fork(watchEventCoachUpdateViewedStatus)
    ]);
}

export default eventCoachSaga;
